import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  label: {
    id: '@lib.core.SelectPCP.label',
    defaultMessage: 'Show times with',
  },
  modePCP: {
    id: '@lib.core.SelectPCP.modePCP',
    defaultMessage: 'Just my primary care doctor',
  },
  modeTeam: {
    id: '@lib.core.SelectPCP.modeTeam',
    defaultMessage: 'My doctor and their team',
  },
});
